import { useState } from 'react';
import { confirmSoftDelete } from '../utils/confirmSoftDelete';
import { runOperation } from '../utils/operationFeedback';

export function useConfigurationSoftDelete() {
  const [busy, setBusy] = useState(false);

  function confirmAndDelete(options: {
    entityLabel: string;
    recordName: string;
    deleteRecord: () => Promise<void>;
    onSuccess: () => void;
    errorMessage: (caught: unknown) => string;
  }) {
    confirmSoftDelete({
      entityLabel: options.entityLabel,
      recordName: options.recordName,
      onConfirm: async () => {
        setBusy(true);
        try {
          await runOperation('delete', options.deleteRecord, {
            failureDetail: options.errorMessage,
          });
          options.onSuccess();
        } catch {
          // runOperation already showed the "Delete failed" popup.
        } finally {
          setBusy(false);
        }
      },
    });
  }

  return { busy, confirmAndDelete };
}
